import { ExpandedSearchInput } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/ExpandedSearchInput/ExpandedSearchInput";

export { ExpandedSearchInput };
